import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCodeMedium: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-outlined-radius-3-stroke-1.5-IconCodeMedium"><Path d="M17.25 7.75L20.605 11.3146C20.9674 11.6997 20.9674 12.3003 20.605 12.6854L17.25 16.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/><Path d="M6.75 16.25L3.39505 12.6854C3.03265 12.3003 3.03265 11.6997 3.39505 11.3146L6.75 7.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></CentralIconBase>;
});

export default IconCodeMedium;
